module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/MC-8b82061f92b329e759e7933ab8fdcf3b.svg";